import Http from '../utils/http'

export const get = (code) => Http.get(`/my-quotation/${code}`)

export const generatePdf = (code) => Http.get(`/my-quotation/${code}/pdf`)

export const approve = (code, payload) => Http.put(`/my-quotation/${code}/approve`, payload)

export const refuse = (code) => Http.put(`/my-quotation/${code}/refuse`)



// WEBPACK FOOTER //
// ./src/services/my-quotation.js